import React from "react";
import { Link } from "react-router-dom";

// Fields shared by the create and edit screens.
const JournalCodeForm = ({
  inputs,
  onChange,
  onSubmit,
  saving,
  submitLabel,
  savingLabel,
  codeHint,
}) => (
  <>
    <div className="coa-panel">
      <div className="coa-panel-head">
        <span>
          <i className="fa fa-hashtag me-2"></i>Journal Code Details
        </span>
        {inputs.code && <span className="coa-code">{inputs.code}</span>}
      </div>
      <div className="coa-panel-body">
        <div className="row">
          <div className="col-lg-3">
            <label>
              Code <i className="fa fa-star required"></i>
            </label>
            <input
              type="text"
              className="form-control coa-mono"
              name="code"
              value={inputs.code || ""}
              onChange={onChange}
              data-required
            />
            {codeHint && <small className="coa-hint">{codeHint}</small>}
          </div>
          <div className="col-lg-9 mg-t-10 mg-lg-t-0">
            <label>
              Name <i className="fa fa-star required"></i>
            </label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={inputs.name || ""}
              onChange={onChange}
              placeholder="e.g. Office Expenses"
              data-required
            />
            <small className="coa-hint">
              Code and name must both be unique.
            </small>
          </div>
        </div>
        <div className="row mg-t-18">
          <div className="col-lg">
            <label>Remarks</label>
            <textarea
              className="form-control"
              name="remarks"
              rows="2"
              value={inputs.remarks || ""}
              onChange={onChange}
              placeholder="What vouchers under this code are used for"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="d-flex justify-content-between align-items-center">
      <Link to="/journal-code" className="btn btn-outline-secondary">
        Cancel
      </Link>
      <button
        type="button"
        className="btn btn-primary"
        onClick={onSubmit}
        disabled={saving}
      >
        <i
          className={`fa ${saving ? "fa-spinner fa-spin" : "fa-send"} mg-r-10`}
        ></i>
        {saving ? savingLabel : submitLabel}
      </button>
    </div>
  </>
);

export default JournalCodeForm;
